import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { IntroAnimation } from "./components/IntroAnimation/IntroAnimation";

function MainContent() {
  return (
    <div className="overflow-hidden">
      <Outlet />
    </div>
  );
}

function App() {
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isHomePage = location.pathname === "/";

    if (!isHomePage) {
      setShowContent(true);
      return;
    }

    const timer = setTimeout(() => {
      setShowContent(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      {!showContent ? (
        <IntroAnimation onComplete={() => setShowContent(true)} />
      ) : (
        <MainContent />
      )}
    </div>
  );
}

export default App;
